import { render, staticRenderFns } from "./GuppyChatHeader.vue?vue&type=template&id=671318a0&"
import script from "./GuppyChatHeader.vue?vue&type=script&lang=js&"
export * from "./GuppyChatHeader.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports